module.exports = __webpack_public_path__ + "img/order_success_animation_frame_1.5167fa80.png";